import { render, staticRenderFns } from "./payMethod.vue?vue&type=template&id=90380a80&scoped=true"
import script from "./payMethod.vue?vue&type=script&lang=js"
export * from "./payMethod.vue?vue&type=script&lang=js"
import style0 from "./payMethod.vue?vue&type=style&index=0&id=90380a80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90380a80",
  null
  
)

export default component.exports